// src/polyfills/cryptoRandomUUID.js

(function ensureCryptoRandomUUID() {
    if (typeof window === 'undefined') return;

    const crypto = window.crypto || window.msCrypto;
    if (!crypto) return;

    if (!crypto.randomUUID) {
        // Basic RFC4122 v4 UUID polyfill
        crypto.randomUUID = function randomUUID() {
            const buf = new Uint8Array(16);

            if (crypto.getRandomValues) {
                crypto.getRandomValues(buf);
            } else {
                for (let i = 0; i < buf.length; i++) {
                    buf[i] = Math.floor(Math.random() * 256);
                }
            }

            // Set version and variant bits per RFC 4122
            buf[6] = (buf[6] & 0x0f) | 0x40; // version 4
            buf[8] = (buf[8] & 0x3f) | 0x80; // variant 10

            const toHex = (n) => n.toString(16).padStart(2, '0');
            const hex = Array.from(buf, toHex).join('');

            return (
                hex.slice(0, 8) + '-' +
                hex.slice(8, 12) + '-' +
                hex.slice(12, 16) + '-' +
                hex.slice(16, 20) + '-' +
                hex.slice(20)
            );
        };
    }
})();
